/** @format */

// Compact, up to 2 decimal places — so a small remainder keeps its fraction («−0,04») instead of
// rounding to a bare «0».
const REMAINDER_FORMAT = new Intl.NumberFormat('ru-RU', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 2,
});

/**
 * Grey "остаток" rendered next to a Факт / Прогноз value: "−N" (proper minus sign
 * U+2212) when negative, "+N" when non-negative. The caller decides the signed value
 * so the «−» always points at the "bad" direction (недобор for KPIs, перерасход for
 * Расход). Shared by KpiTable and SpendSection.
 */
export const formatRemainder = (value: number): string => {
  // Round to 2 decimals before picking the sign so a tiny negative that rounds to zero reads as
  // «+0» (−0 >= 0), never a contradictory «−0».
  const rounded = Math.round(value * 100) / 100;
  const abs = REMAINDER_FORMAT.format(Math.abs(rounded));
  return rounded >= 0 ? `+${abs}` : `−${abs}`;
};
